seedWebApp.controller('DashboardCustomersController', ['$scope', '$rootScope', '$window', '$route', 'ContactService',
    function ($scope, $rootScope, $window, $route, ContactService) {
        console.log('dashboardCustomers');

        
    }]
);
